// import React, { useState, useMemo, useCallback } from "react";
// import { Input } from "../../ui/Input";
// import { Select } from "../../ui/Select";
// import { RadioGroup } from "../../ui/RadioGroup";
// import useCountries from "../../../hooks/useCountries";
// import useDeligenceStatus from "../../../hooks/useDeligenceStatus";
// import { diligenceObservable } from "../../../observers/deligenceObservable";
// import { CountryRiskPopup } from "../../popups/countryRiskPopup";
// import { yesNoOption } from "../../options/options";

// export const PrivateIndividualForm = React.memo(({renderBy, index, formData, onChange, isReadOnly, isReport}) => {

//     const countries = useCountries();
//     const { getDeligenceStatusByCountry } = useDeligenceStatus();
//     const ownerId = useMemo(()=>{ return renderBy + index.toString() + "PrivateIndividual"}, [index, renderBy]);
//     const [showPopup, setShowPopup] = useState(false);

//     const handleNationalityChange = useCallback(async (event) => {
//         diligenceObservable.remove(ownerId);
//         const selectedCountry = event.target.value;
//         const name = event.target.name;
//         if (selectedCountry !== "None") {
//             const response = await getDeligenceStatusByCountry(selectedCountry);
//             if (response) {
//                 const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
//                 if (hasEnhanced) {
//                     setShowPopup(true);   
//                 }
//             }
//         }
//         let privateEvent = { target: { name: name, value: selectedCountry } };
//         onChange(privateEvent);
//     }, [getDeligenceStatusByCountry, onChange, ownerId]); 

//     return (
//         <>
//             <Input 
//                 label={"Full Name"}
//                 name={"ubofullName"}
//                 disabled={isReadOnly}
//                 value={formData.ubofullName}
//                 isReport={isReport}
//                 onChange={onChange}
//             />

//             <Select 
//                 label={"Nationality"}
//                 name={"uboNationality"}
//                 disabled={isReadOnly}
//                 value={formData.uboNationality}
//                 onChange={handleNationalityChange}
//                 isReport={isReport}
//                 options={countries.map((value)=>({ value: value, display_value: value }))}
//             />

//             <Input 
//                 label={"Contact Details"}
//                 name={"uboContactDetails"}
//                 disabled={isReadOnly}
//                 value={formData.uboContactDetails}
//                 isReport={isReport}
//                 onChange={onChange}
//             />

            

//             <RadioGroup 
//                 label={"Have you met this individual face to face?"}
//                 name={"uboMet"}
//                 value={formData.uboMet}
//                 disabled={isReadOnly}
//                 onChange={onChange}
//                 isReport={isReport}
//                 options={yesNoOption}
//             />
//             {showPopup && diligenceObservable.isEnhanced() === false && <CountryRiskPopup ownerId={ownerId} openPopup={true}/>}
//             {/* {showPopup && diligenceObservable.isEnhanced() === true && <AlreadyEnhancedPopup openPopup={true}/>} */}
//         </>
//     );
// });



import React, { useState, useMemo, useCallback } from "react";
import { Input } from "../../ui/Input";
import { Select } from "../../ui/Select";
// import {select} from "../../ui/Selectelect";
// import { SelectCountry } from "../../ui/SelectCountry";  // ✅ Import added
import { SelectCountry } from "../../selectors/country/selectCountry";
import { RadioGroup } from "../../ui/RadioGroup";
import useCountries from "../../../hooks/useCountries";
import useDeligenceStatus from "../../../hooks/useDeligenceStatus";
import { diligenceObservable } from "../../../observers/deligenceObservable";
import { CountryRiskPopup } from "../../popups/countryRiskPopup";
import { yesNoOption } from "../../options/options";

export const PrivateIndividualForm = React.memo(({ renderBy, index, formData, onChange, isReadOnly, isReport }) => {
    const countries = useCountries();
    const { getDeligenceStatusByCountry } = useDeligenceStatus();
    const ownerId = useMemo(() => renderBy + index.toString() + "PrivateIndividual", [index, renderBy]);
    const [showPopup, setShowPopup] = useState(false);

    const handleNationalityChange = useCallback(async (event) => {
        diligenceObservable.remove(ownerId);
        const selectedCountry = event.target.value;
        const name = event.target.name;
        if (selectedCountry !== "None") {
            const response = await getDeligenceStatusByCountry(selectedCountry);
            if (response) {
                const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
                if (hasEnhanced) {
                    setShowPopup(true);
                }
            }
        }
        let privateEvent = { target: { name: name, value: selectedCountry } };
        onChange(privateEvent);
    }, [getDeligenceStatusByCountry, onChange, ownerId]);

    return (
        <>
            <Input
                label={"Full Name"}
                name={"ubofullName"}
                disabled={isReadOnly}
                value={formData.ubofullName}
                isReport={isReport}
                onChange={onChange}
                required
            />

            <SelectCountry
                label={"Nationality"}
                name={"uboNationality"}
                disabled={isReadOnly}
                value={formData.uboNationality}
                onChange={handleNationalityChange}
                isReport={isReport}
                options={countries.map((value) => ({ value, display_value: value }))}
                required
            />

            {/* <Input 
                label={"Contact Details"}
                name={"uboContactDetails"}
                disabled={isReadOnly}
                value={formData.uboContactDetails}
                isReport={isReport}
                onChange={onChange}
            /> */}

            <Input
                type="date"
                label={"Date of Birth"}
                name={"ubodateOfBirth"}
                disabled={isReadOnly}
                value={formData.ubodateOfBirth}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <Input 
                label={"Residential Address Line 1"}
                name={"uboaddressLine1"}
                required
                disabled={isReadOnly}
                value={formData.uboaddressLine1}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Residential Address Line 2"}
                name={"uboaddressLine2"}
                disabled={isReadOnly}
                value={formData.uboaddressLine2}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Residential Address Line 3"}
                name={"uboaddressLine3"}
                disabled={isReadOnly}
                value={formData.uboaddressLine3}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"City"}
                name={"ubocity"}
                required
                disabled={isReadOnly}
                value={formData.ubocity}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"County/State"}
                name={"ubostate"}
                disabled={isReadOnly}
                value={formData.ubostate}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Postal Code"}
                name={"ubopostalCode"}
                required
                disabled={isReadOnly}
                value={formData.ubopostalCode}
                onChange={onChange}
                isReport={isReport}
            />

            <SelectCountry
                label={"Country"}
                name={"ubocountry"}
                required
                disabled={isReadOnly}
                value={formData.ubocountry}
                onChange={handleNationalityChange}
                isReport={isReport}
            />

            <RadioGroup
                label={"Have you met this individual face to face?"}
                name={"uboMet"}
                value={formData.uboMet}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                options={yesNoOption}
                required
            />

            <RadioGroup
                label={"Is this person the sole director for the entity?"}
                name={"ubosoleDirector"}
                value={formData.ubosoleDirector}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                options={yesNoOption}
                required
                />

            {showPopup && !diligenceObservable.isEnhanced() && (
                <CountryRiskPopup ownerId={ownerId} openPopup={true} />
            )}
        </>
    );
});
